var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c("v-flex", { attrs: { xs4: "" } }, [
        _vm._v(_vm._s(_vm.splitByAllCapitalLetters(_vm.field.Field))),
      ]),
      _vm._v(" "),
      _c("v-flex", { attrs: { xs8: "" } }, [
        _vm._v(_vm._s(_vm.field.FieldValue)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }